import {
    SEARCH_PRODUCTS,
    SET_PRODUCT_CATEGORIES,
    SET_PRODUCT,
    SEARCH_PRODUCT_CATEGORIES,
    SEARCH_PRODUCT_OF_SELECTED_CATEGORY,
    SET_SELECTED_PRODUCT_DESIGNATION,
} from './productConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialState = {
    searchProducts: [],
    productCategories: [],
    products: [],
    searchProductCategories: [],
    productsOfSelectedCategory: [],
    selectedProductDesignation: "",
};

export function products(state = initialState, action) {
    switch (action.type) {
        case SEARCH_PRODUCTS:
            return setValue(state, ['searchProducts'], action.products);
        case SET_PRODUCT_CATEGORIES:
            return setValue(state, ['productCategories'], action.categories);
        case SET_PRODUCT:
            return setValue(state, ['products'], action.products);
        case SEARCH_PRODUCT_CATEGORIES:
            return setValue(state, ['searchProductCategories'], action.productCategories);
        case SEARCH_PRODUCT_OF_SELECTED_CATEGORY:
            return setValue(state, ['productsOfSelectedCategory'], action.productsOfSelectedCategory);
        case SET_SELECTED_PRODUCT_DESIGNATION:
            return setValue(state, ['selectedProductDesignation'], action.designation)
        default:
            return state;
    }
}
